import React, { useEffect } from 'react';
import clsx from 'clsx';
import { config } from '../../config';

interface IGoogleLoginBtnProps {
  handleCallback: (resposne: any) => void,
  className?: string,
  theme?: string,
  size?: string,
  width?: number,
}

const GoogleLoginBtn = ({ handleCallback, className, theme = 'outline', size = 'large', width = 360 }: IGoogleLoginBtnProps) => {
  useEffect(() => {
    /* global google */
    // @ts-ignore
    google.accounts.id.initialize({
      client_id: config.clientId,
      callback: handleCallback
    });

    // @ts-ignore
    google.accounts.id.renderButton(
      document.getElementById('google_sign_in'),
      {
        type: 'standard',
        text: 'continue_with',
        theme,
        size,
        width }
    );
  }, []);

  return (
     <div
        className={clsx(className)}
        id="google_sign_in"
     />
  );
};

export default GoogleLoginBtn;
